import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'
import { Actionable } from './actionable.js'

export const ProcedureTypes = [
	['procedure', 'Stored Procedure'],
	['function', 'SQL Function'],
] as const
export type ProcedureType = (typeof ProcedureTypes)[number][0]
export const DbToTsType = {
	int: 'number',
	varchar: 'string',
	bool: 'boolean',
} as const
export type InputType = keyof typeof DbToTsType

@jsonClass('ServerDataStoreProcedure')
export class ServerDataStoreProcedure extends Actionable {
	@jsonProperty(String)
	type: ProcedureType = 'procedure'

	constructor(init?: Partial<ServerDataStoreProcedure>) {
		super()
		assignCommonProperties(this, init)
	}
}
